module.exports = new __parcel__URL__("pvp_ap_icon.83a4a9bd.png").toString();